import { render, staticRenderFns } from "./NarrativeReportModal.vue?vue&type=template&id=2ef9584c&scoped=true&"
import script from "./NarrativeReportModal.vue?vue&type=script&lang=js&"
export * from "./NarrativeReportModal.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeReportModal.vue?vue&type=style&index=0&id=2ef9584c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9584c",
  null
  
)

export default component.exports